<template>
  <div v-if="active" class="tab-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    context: {
      required: true,
    },
  },
  computed: {
    active: function() {
      return this.id === this.context.activeTabId;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.tab-content {
  padding: 6px 6px;
  border: 1px solid $gray-500;
  border-radius: 0px 0px $border-radius $border-radius;
  overflow: hidden;
}
</style>
